<template>
    <div id="DiscussList" class="discuss-history-list">
        <!-- 1、时间:::Todo:::时间显示规则 -->
        <!-- <div class="discuss-history-list-time">2019年4月3日 16:28</div> -->

        <!-- 1、未登录状态 -->
        <div v-if="!hasLogined" class="discuss-history-list-note">
            <p>登录中...</p>
            <p>快分享给好友一起来论盘吧！</p>
        </div>
        <!-- 2、已登录，无论盘记录状态 -->
        <div v-if="hasLogined && lunpanHistoryList.length == 0">
            <div class="discuss-title">论盘标题:<span class="discuss-title-span">{{lunpanData.title}}</span><i class="iconfont icon-edit" @click.stop='clickEdit'></i></div>
            <div class="discuss-history-list-note">
                <p>还没有论盘记录诶～</p>
                <p>快分享给好友一起来论盘吧！</p>
            </div>
        </div>
        <!-- 3、已登录，有论盘记录状态 -->
        <!-- <virtual-list v-if="lunpanHistoryList.length > 0" id="DiscussList" :size="6*9" :remain="10"> -->
        <div v-if="lunpanHistoryList.length > 0" class="discuss-history-list-scroll">
        <!-- <discuss-scroll v-if="lunpanHistoryList.length > 0" class="discuss-history-list-scroll"
            :pulldown="true"
            :data="lunpanHistoryList"> -->
            <div class="discuss-title">论盘标题:<span class="discuss-title-span">{{lunpanData.title}}</span><i class="iconfont icon-edit" @click.stop='clickEdit'></i></div>

            <div v-if="lunpanRefreshing" class="discuss-loading">
                <div class="lds-dual-ring"></div>
            </div>

            <!-- 2、聊天气泡:我发的 -->
            <div v-for="discussData of lunpanHistoryList" v-bind:key="'discuss-history-item' + discussData.nickname + Math.random(0, 10)" class="discuss-chat-panel dsp-flex">
                <!-- 他人头像 -->
                <div v-if="discussData.uid != curUserUid" class="discuss-cal-alpha-box discuss-cal-other" v-longpress="longPressAvatar" @click="clickAvatar" >
                    <keep-alive>
                        <div v-bind:class="{'discuss-chat-donate-alpha': donate == 1}">
                            <div>
                                <img class="discuss-chat-alpha" :src="discussData.avatarUrl" alt="">
                                <span v-if="donate == 1" class="discuss-chat-donate-icon"></span>
                            </div>
                        </div>
                    </keep-alive>
                    <span v-if="donate == 1" class="discuss-donate-icon"></span>
                </div>
                <div class="discuss-chat-content" v-bind:class="{'discuss-cc-left': discussData.uid == curUserUid, 'discuss-cc-right': discussData.uid != curUserUid}">
                    <div v-if="discussData.uid != curUserUid" class="discuss-chat-nickname">{{discussData.nickname}}</div>
                    <div v-if="discussData.type == 'text'" class="discuss-chat-text" v-bind:class="{'discuss-chat-text-my': discussData.uid == curUserUid, 'discuss-chat-text-other': discussData.uid != curUserUid}">
                        <p v-html="UTILS.getBreakLineByText(discussData.content)"></p>
                    </div>
                    <img v-if="discussData.type == 'image'" class="discuss-chat-img" v-bind:class="{'discuss-chat-img-my': discussData.uid == curUserUid, 'discuss-chat-img-other': discussData.uid != curUserUid}" :src="discussData.content" alt="">
                </div>
                <!-- 我的头像 -->
                <div v-if="discussData.uid == curUserUid" class="discuss-cal-alpha-box">
                    <keep-alive>
                        <div v-bind:class="{'discuss-chat-donate-alpha': donate == 1}">
                            <div>
                                <img class="discuss-chat-alpha" :src="discussData.avatarUrl" alt="">
                                <span v-if="donate == 1" class="discuss-chat-donate-icon"></span>
                            </div>
                        </div>
                    </keep-alive>
                    <span v-if="donate == 1" class="discuss-donate-icon"></span>
                </div>
            </div>
            <div v-if="lunpanData.isEnd == 1" class="discuss-end-note">----该论盘已结束----</div>
        </div>
        <!-- </discuss-scroll> -->
        <!-- </virtual-list> -->
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
import { WEIXIN } from '../../modules/weixin';
export default {
    name: 'DiscussHistoryList',
    computed: {
        hasLogined() {
            return this.$store.state.discuss.hasLogined;
        },
        curUserUid() {
            return this.$store.state.discuss.curUserUid;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanHistoryList() {
            return this.$store.state.discuss.lunpanHistoryList;
        },
        lunpanRefreshing() {
            return this.$store.state.discuss.lunpanRefreshing;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            donate: 0
        }
    },
    methods: {
        clickEdit() {
            this.$store.state.discuss.showDiscussEditPop = true;
        },
        longPressAvatar() {
            console.log('longPressAvatar')
        },
        clickAvatar() {
            console.log('clickAvatar--------')
        }
    }
}
</script>